import NativoTout from 'components/Nativo/NativoTout';
import SubscriptionPlea from 'components/SubscriptionPlea';
import type { Article } from 'interfaces/content/articles/Articles';
import RelatedVideo from 'components/RelatedVideo';
import type { BrandedArticle } from 'interfaces/content/articles/Post';

function setArticleEmbeds(article: Article | BrandedArticle, supressSTNVideo: boolean = false) {
  const embeds = [
    {
      component: (
        <NativoTout
          featuredMediaType={article.featuredMediaType}
          key='NativoTout'
        />
      ),
      index: 12,
      node: 'p',
    },
    {
      component: (
        <SubscriptionPlea
          enableSubscriptionPlea={article.postSettings.enableSubscriptionPlea}
          subscriptionPleaTextLined={article.postSettings.subscriptionPleaTextLined}
          pageType={article.pageType}
          key='SubscriptionPlea'
        />
      ),
      index: -1,
      node: '',
    },
  ];

  const isStnVideo = article.relatedVideoType === 'stn_video_media';
  if (isStnVideo || article.relatedVideoType === 'video_media') {
    embeds.splice(2, 0, {
      component: (
        <RelatedVideo
          article={article}
          key='RelatedVideo'
          supressStnFloating={supressSTNVideo}
        />
      ),
      index: 0,
      node: 'p',
    });
  }

  return embeds;
}

export default setArticleEmbeds;
